if (typeof window !== "undefined") {
    window.chameleonControlsLibrary ??= { getImagePathCallback: {} };
    window.chameleonControlsLibrary.getImagePathCallback ??= {};
}
export const registryProperty = (propertyName, value) => {
    if (propertyName === "__proto__" ||
        propertyName === "constructor" ||
        propertyName === "prototype") {
        throw new Error("Invalid property name");
    }
    window.chameleonControlsLibrary[propertyName] = value;
};
export const registryControlProperty = (propertyName, controlName, value) => {
    if (propertyName === "__proto__" ||
        propertyName === "constructor" ||
        propertyName === "prototype") {
        throw new Error("Invalid property name");
    }
    if (controlName === "__proto__" ||
        controlName === "constructor" ||
        controlName === "prototype") {
        throw new Error("Invalid control name");
    }
    window.chameleonControlsLibrary[propertyName][controlName] = value;
};
export const getControlRegisterProperty = (propertyName, controlName) => window.chameleonControlsLibrary[propertyName][controlName];
export const DEFAULT_GET_IMAGE_PATH_CALLBACK = additionalItem => ({
    base: additionalItem.imgSrc
});
